export const getVisiblePageNumbers = (currentPage, totalPages) => {
  if (totalPages <= 0) return [];
  if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);

  const pageSet = new Set([1, 2, 3, currentPage - 1, currentPage, currentPage + 1, totalPages]);
  const sortedPages = [...pageSet]
    .filter((page) => page >= 1 && page <= totalPages)
    .sort((a, b) => a - b);

  const visiblePages = [];
  sortedPages.forEach((page, index) => {
    if (index > 0 && page - sortedPages[index - 1] > 1) visiblePages.push('ellipsis');
    visiblePages.push(page);
  });

  return visiblePages;
};
